<template>
  <div class="w-3/4 lg:w-1/3 xl:w-1/5 bg-white mb-10 xl:mb-0 lg:mx-6 overflow-hidden shadow-2xl"
       style="border-radius: 25px;">
    <img class="w-full object-contain" :src="require(`@/assets/img/landing_photos/${image}`)" alt="">
    <div class=" flex flex-col flex-wrap justify-center items-center mx-3 my-3 px-4">
      <h2 class="text-3xl font-bold border-b-2 border-yellow-primary text-center w-5/4">
        {{title}}
      </h2>
      <p class="text-left w-full p-8 pt-5 pb-0 font-text text-blackish-2 text-lg">
        {{info}}
      </p>

      <a href="#" class="block h-10 px-5 pt-2 pb-5 mt-16 mb-4 font-display border-yellow-primary bg-yellow-primary rounded-full">
        View full</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CaseStudyListItem',
    props: {
      title: String,
      info: String,
      image: String
    }
  }
</script>
